































import Vue, { PropOptions } from 'vue';
import SAlert from '../../../SAlert/SAlert.vue';
import SButton from '../../../SButton/SButton.vue';

export default Vue.extend({
  name: 'STableSelectAllBanner',
  components: {
    SAlert,
    SButton,
  },
  props: {
    mode: {
      type: String,
    } as PropOptions<'ADD' | 'REMOVE'>,
    noValidPageItems: {
      type: Number,
    },
    totalItemCount: {
      type: Number,
    },
  },
  data(): any {
    return {
      allSelected: false,
    };
  },
  computed: {
    selectAllBannerButtonText(): string {
      return this.allSelected || this.mode === 'REMOVE'
        ? 'Clear selection'
        : `Select all ${this.totalItemCount} items`;
    },
    selectAllBannerText(): string {
      if (this.mode === 'REMOVE') return `${this.totalItemCount} items are selected.`;
      return this.allSelected
        ? `All ${this.totalItemCount} items are selected.`
        : `All ${this.noValidPageItems} items on this page are selected.`;
    },
  },
  methods: {
    selectAllBannerButtonClick() {
      if (this.mode === 'ADD') this.allSelected = !this.allSelected;

      // Clicked the 'Clear selection' button
      if (!this.allSelected || this.mode === 'REMOVE') {
        this.allowSelectAllBanner = false;
        this.$emit('clear');
        this.$emit('close');
        return;
      }

      this.$emit('selectAll');
    },
  },
});
